<template>
  <div class="sub-select-group option">
    <div class="bubble" id="sub-group-bike" v-if="categories.length > 0">
      <p class="select_list" v-for="category in categories" :key="category.id">
        <input type="checkbox" name="category" :id="category.id">
        <label class="font-text ja is-2" :for="category.id">{{ category.title }}</label>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "option_categories",
  props: ['parentCategory', 'categories']
}
</script>
